import { render } from "./DataChoice.vue?vue&type=template&id=194c4732&scoped=true"
import script from "./DataChoice.vue?vue&type=script&lang=js"
export * from "./DataChoice.vue?vue&type=script&lang=js"

import "./DataChoice.vue?vue&type=style&index=0&id=194c4732&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194c4732"]])

export default __exports__